import React from "react";
import { Flex, Spin } from "antd";

const loadingStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "fixed",
  backgroundColor: "rgba(255, 255, 255, 0.5)",
  height: "100vh",
  width: "100vw",
  zIndex: 999,
};
const Loading = () => {
  return (
    <div style={loadingStyle}>
      <Flex align="center" gap="middle">
        <Spin size="large" />
      </Flex>
    </div>
  );
};


Loading.propTypes = {

};

export default Loading;
